// Constantes et calculs de dates du module RH.
export const STATUTS = {
  PRESENT: { label: 'Présent', code: 'P', bg: '#DCEFE3', fg: '#1B6B3F' },
  RETARD: { label: 'Retard', code: 'R', bg: '#FCEBCB', fg: '#8A5A00' },
  ABSENT_J: { label: 'Absence justifiée', code: 'AJ', bg: '#DCE8F5', fg: '#22558A' },
  ABSENT_NJ: { label: 'Absence injustifiée', code: 'AI', bg: '#F8D9DA', fg: '#9B1C22' },
  NON_POINTE: { label: 'Non pointé', code: 'NP', bg: '#FBE4E0', fg: '#A2402E' },
  CONGE: { label: 'Congé', code: 'C', bg: '#E7E1F5', fg: '#57409A' },
  FERIE: { label: 'Jour férié', code: 'F', bg: '#ECEEF1', fg: '#5B6675' },
  REPOS: { label: 'Repos', code: '', bg: '#F4F5F7', fg: '#9AA3AF' },
  SUPPLEMENTAIRE: { label: 'Travail jour de repos', code: 'S', bg: '#D7EEF0', fg: '#1E6A72' },
  EN_ATTENTE: { label: 'Pas encore pointé', code: '?', bg: '#FFFFFF', fg: '#5B6675' },
  A_VENIR: { label: 'À venir', code: '', bg: '#FFFFFF', fg: '#C3C9D1' },
  HORS_CONTRAT: { label: 'Hors contrat', code: '', bg: '#F4F5F7', fg: '#C3C9D1' },
};

export const MOTIFS = {
  MALADIE: 'Maladie', PERMISSION: 'Permission', MISSION: 'Mission', FORMATION: 'Formation',
  INJUSTIFIEE: 'Injustifiée', AUTRE: 'Autre',
};
export const TYPES_CONGE = {
  ANNUEL: 'Congé annuel', EXCEPTIONNEL: 'Permission exceptionnelle', MATERNITE: 'Maternité',
  PATERNITE: 'Paternité', SANS_SOLDE: 'Sans solde',
};
export const STATUTS_CONGE = {
  DEMANDE: { label: 'En attente', color: 'warning' },
  APPROUVE: { label: 'Approuvé', color: 'success' },
  REFUSE: { label: 'Refusé', color: 'error' },
  ANNULE: { label: 'Annulé', color: 'default' },
};
export const CONTRATS = { CDI: 'CDI', CDD: 'CDD', JOURNALIER: 'Journalier', STAGE: 'Stage', AUTRE: 'Autre' };
export const JOURS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
export const MOIS_COURTS = ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'];

const parse = (d) => new Date(`${d}T00:00:00Z`);
const fmt = (dt) => dt.toISOString().slice(0, 10);
export const todayIso = () => {
  const n = new Date();
  return fmt(new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())));
};
export const addDays = (d, n) => fmt(new Date(parse(d).getTime() + n * 86400000));
export const isoDow = (d) => parse(d).getUTCDay() || 7;

/** Bornes de la période contenant la date de référence. */
export function periodRange(mode, ref) {
  const dt = parse(ref);
  const y = dt.getUTCFullYear();
  const m = dt.getUTCMonth();
  if (mode === 'jour') return { from: ref, to: ref };
  if (mode === 'semaine') { const from = addDays(ref, 1 - isoDow(ref)); return { from, to: addDays(from, 6) }; }
  if (mode === 'mois') return { from: fmt(new Date(Date.UTC(y, m, 1))), to: fmt(new Date(Date.UTC(y, m + 1, 0))) };
  return { from: `${y}-01-01`, to: `${y}-12-31` };
}

/** Déplace la date de référence d'une période. */
export function shiftRef(mode, ref, dir) {
  const dt = parse(ref);
  if (mode === 'jour') return addDays(ref, dir);
  if (mode === 'semaine') return addDays(ref, 7 * dir);
  if (mode === 'mois') return fmt(new Date(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth() + dir, 1)));
  return `${dt.getUTCFullYear() + dir}-01-01`;
}

export function periodLabel(mode, ref) {
  const dt = parse(ref);
  if (mode === 'jour') {
    return dt.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  }
  if (mode === 'semaine') {
    const { from, to } = periodRange('semaine', ref);
    const a = parse(from); const b = parse(to);
    return `Semaine du ${a.getUTCDate()} ${MOIS[a.getUTCMonth()]} au ${b.getUTCDate()} ${MOIS[b.getUTCMonth()]} ${b.getUTCFullYear()}`;
  }
  if (mode === 'mois') return `${MOIS[dt.getUTCMonth()].replace(/^./, (c) => c.toUpperCase())} ${dt.getUTCFullYear()}`;
  return `Année ${dt.getUTCFullYear()}`;
}

export const dayNum = (d) => parse(d).getUTCDate();
export const dayShort = (d) => JOURS[isoDow(d) - 1];

/** 125 → « 2 h 05 » */
export function duree(min) {
  const m = Math.round(Number(min) || 0);
  if (!m) return '0';
  const h = Math.floor(m / 60);
  const r = m % 60;
  return h ? `${h} h ${String(r).padStart(2, '0')}` : `${r} min`;
}

/** Export CSV lisible par Excel (séparateur « ; », BOM UTF-8). */
export function downloadCsv(filename, header, rows) {
  const esc = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[;"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [header, ...rows].map((r) => r.map(esc).join(';')).join('\r\n');
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
